import DashboardHome from "components/EnsembleComponents/ReportsManagement/Dashboard/DashboardHome";
import Dashboard2Home from "components/EnsembleComponents/ReportsManagement/Dashboard2/Dashboard2Home";
import React from "react";
import { Route, Switch } from 'react-router-dom';  // Enables routing between the components
import ViewDashboard from '../../Dashboard/ViewDashboard';

  
const DashboardSubRouting = ({ match }) =>  {
    return (
        <div style={{height:'100%'}}>
            <Switch>
            <Route path={'/Dashboard'} component={DashboardHome}/>   
            <Route path={'/Dashboard2'} component={Dashboard2Home}/>   
                <Route path='/Graphics/Dashboards/:dashName' component={ViewDashboard}/>
            </Switch>
        </div>  
    );
}

export default DashboardSubRouting;